import styled from 'styled-components';

export default styled.div.attrs(({ theme }) => ({
  dangerouslySetInnerHTML: {
    __html: theme.warningIcon
  }
}))`
  ${({ theme }) => theme.PermissionWarningIcon}
`;
